export default "//static.tradera.net/touchweb/static/output/images/app-store-badge-da.21f42397.svg";